import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import PropTypes from 'prop-types';

import setupComplete from 'lib/setupComplete';

const setupUrl = '/account-setup';
const profileUrl = '/profile';

const checkLogin = (props, history) => {
  if (!props.authenticated) {
    history.push('/');
    return;
  }

  let extra = '';

  if (document.location.search) {
    extra += document.location.search;
  }

  if (document.location.hash) {
    extra += document.location.hash;
  }

  if (props.user && !setupComplete(props.user)) {
    if (document.location.pathname !== setupUrl) {
      history.push(setupUrl + extra);
    }

    return;
  }

  if (
    get(props, 'user.nonprofit') &&
    get(props, 'user.nonprofit.payment_profile.payment_status') !== true
  ) {
    if (document.location.pathname !== profileUrl) {
      history.push(`${profileUrl}#payment`);
    }

    return;
  }
};

export default function(ComposedComponent) {
  class Auth extends Component {
    componentWillMount() {
      checkLogin(this.props, this.props.history);
    }

    componentWillUpdate(nextProps) {
      checkLogin(nextProps, this.props.history);
    }

    PropTypes = {
      router: PropTypes.object
    };

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      authenticated: state.login.authenticated,
      user: state.login.user
    };
  }

  return connect(mapStateToProps)(Auth);
}



// WEBPACK FOOTER //
// ./src/components/util/AuthComponent.js